export default {"src":"/_next/static/media/automated-analysis.b684294b.svg","height":512,"width":576,"blurWidth":0,"blurHeight":0};